import { Injectable } from '@angular/core';

// import { Usuario } from 'app/modulos/empresa/entities/usuario'
// import { ServiceCRUD } from 'app/modulos/core/services/service-crud.service'
import { HttpHeaders } from '@angular/common/http';
import { Usuario } from '../../empresa/entities/usuario';
import { CRUDService } from '../../core/services/crud.service';

@Injectable()
export class UsuarioService extends CRUDService<Usuario>{
  
  
  aceptarTerminos(acepta: boolean): any {
    return new Promise(resolve => {
      this.httpInt.put(this.end_point + 'terminos/' + acepta, null)
        .subscribe(
          res => {
            resolve(res);
          }
          ,
          err => this.manageError(err)
        )
    });
  }

  createUsuarioAliado(entity: Usuario, aliadoId: string): Promise<Usuario>{
    let body = JSON.stringify(entity);
    return new Promise((resolve, reject) => {
        this.httpInt
            .post(this.end_point + 'aliado/' +aliadoId, body)
            .subscribe(
                (res) => {
                    resolve(res);
                },
                (err) => {
                    reject(err);
                    this.manageError(err);
                }
            );
    });
  }

  createUsuarioProveedor(entity: Usuario, idEmpresaProveedor: string): Promise<Usuario>{
    let body = JSON.stringify(entity);
    const url = this.end_point + 'proveedor/' + idEmpresaProveedor;
    
    // Debug: verificar la URL que se está construyendo
    console.log('🔍 Debug - UsuarioService.createUsuarioProveedor:', {
      endpoint: this.end_point,
      idEmpresaProveedor,
      fullUrl: url,
      entityBody: entity
    });
    
    return new Promise((resolve, reject) => {
        this.httpInt
            .post(url, body)
            .subscribe(
                (res) => {
                    resolve(res);
                },
                (err) => {
                    console.error('❌ Error en createUsuarioProveedor:', err);
                    reject(err);
                    this.manageError(err);
                }
            );
    });
  }

  // Método para obtener usuarios de un proveedor específico
  getUsuariosByProveedor(idEmpresaProveedor: string): Promise<Usuario[]> {
    const url = this.end_point + 'proveedor/' + idEmpresaProveedor + '/usuarios';
    
    console.log('🔍 Debug - UsuarioService.getUsuariosByProveedor:', {
      endpoint: this.end_point,
      idEmpresaProveedor,
      fullUrl: url
    });
    
    return new Promise((resolve, reject) => {
      this.httpInt
        .get(url)
        .subscribe(
          (res: any) => {
            console.log('🔍 Debug - Respuesta raw del backend:', res);
            
            // Manejar diferentes formatos de respuesta del backend
            let usuarios: Usuario[] = [];
            
            if (Array.isArray(res)) {
              // Si la respuesta es directamente un array
              usuarios = res as Usuario[];
            } else if (res && Array.isArray(res.data)) {
              // Si la respuesta tiene formato {data: [...]}
              usuarios = res.data as Usuario[];
            } else if (res && typeof res === 'object') {
              // Si es un objeto, intentar convertirlo en array de un solo elemento
              usuarios = [res as Usuario];
            } else {
              // Si no es ninguno de los formatos esperados, usar array vacío
              console.warn('⚠️ Formato de respuesta inesperado:', typeof res, res);
              usuarios = [];
            }
            
            console.log('✅ Usuarios procesados:', usuarios.length, usuarios);
            resolve(usuarios);
          },
          (err) => {
            console.error('❌ Error en getUsuariosByProveedor:', err);
            reject(err);
            this.manageError(err);
          }
        );
    });
  }

  // Método para inactivar usuario
  inactivarUsuario(usuarioId: string): Promise<Usuario> {
    return new Promise((resolve, reject) => {
      this.httpInt.put(this.end_point + 'inactivar/' + usuarioId, null)
        .subscribe(
          (res: any) => {
            console.log('✅ Usuario inactivado exitosamente:', res);
            resolve(res);
          },
          (err) => {
            console.error('❌ Error inactivando usuario:', err);
            reject(err);
            this.manageError(err);
          }
        );
    });
  }

  sendMailAliadoActualizar(entity: string, aliadoId: string) {
    let body = entity;
    // let body = JSON.stringify(entity);
    return new Promise((resolve, reject) => {
        this.httpInt
            .put(this.end_point + 'aliadoActualizar/' +aliadoId, body)
            .subscribe(
                (res) => {
                    resolve(res);
                },
                (err) => {
                    reject(err);
                    this.manageError(err);
                }
            );
    });
  }

  emailAliadoActualizado(entity: string, aliadoId: string) {
    let body = entity;
    // let body = JSON.stringify(entity);
    return new Promise((resolve, reject) => {
        this.httpInt
            .put(this.end_point + 'emailAliadoActualizado/' +aliadoId, body)
            .subscribe(
                (res) => {
                    resolve(res);
                },
                (err) => {
                    reject(err);
                    this.manageError(err);
                }
            );
    });
  }

  emailAliadoCicloCorto(entity: string, inspeccionId: string) {
    let body = entity;
    return new Promise((resolve, reject) => {
        this.httpInt
            .put(this.end_point + 'emailAliadoCicloCorto/'+inspeccionId, body)
            .subscribe(
                (res) => {
                    resolve(res);
                },
                (err) => {
                  this.manageError(err);
                  reject(err);
                }
            );
    });
  }

  consultarHistoriaLogin(){
    return new Promise(resolve => {
      this.httpInt.get(this.end_point + 'historiaLogin/')
        .subscribe(
          res => {
            resolve(res);
          }
          ,
          err => this.manageError(err)
        )
    });
  }


  cambiarPasswd(newPasswd: string, newPasswdConfirm: string, oldPasswd: string) {
    let body = { 'passwdAnterior': oldPasswd, 'passwdNuevo': newPasswd, 'passwdNuevoConfirm': newPasswdConfirm };
    return new Promise(resolve => {
      this.httpInt.put(this.end_point + 'cambiarPasswd', JSON.stringify(body))
        .subscribe(
          res => {
            resolve(res);
          }
          ,
          err => this.manageError(err)
        )
    });
  }

  /**
   * Modifica los datos de usuario por parte del mismo usuario.
   * No es permitido que un usuario modifique datos de otro a través
   * éste servicio
   * @param entity 
   */
  edit(entity: Usuario) {
    let body = JSON.stringify(entity);
    return new Promise(resolve => {
      this.httpInt.put(this.end_point + 'update', body)
        .subscribe(
          res => {
            resolve(res);
          }
          ,
          err => this.manageError(err)
        )
    });
  }
  inactivar(id: number| string): Promise<any> {
    return new Promise(resolve => {
      this.httpInt.put(this.end_point + 'inactivar/' + id, {})
        .subscribe(
          res => resolve(res),
          err => this.manageError(err)
        );
    });
  }
  

  consultarConsolidado(): any {
    
    return new Promise((resolve, reject) => {
      let options: any = {
        responseType: 'blob',
        headers: new HttpHeaders()
          .set('Param-Emp', this.httpInt.getSesionService().getParamEmp())
          .set('app-version', this.httpInt.getSesionService().getAppVersion())
          .set('Authorization', this.httpInt.getSesionService().getBearerAuthToken())
      };
      this.httpInt.http.get(this.end_point + "consusuarios/", options)
        .subscribe(
          res => resolve(res),
          err => {
            reject(err);
            this.manageBlobError(err)
          }
        )
    });
  }


  getClassName(): string {
    return "UsuarioService";
  }
}
